import * as React from "react";
import { ThemeBreakpoints, ThemePalette } from "@vwpfs/mary-air-lib/theme/_Types";
import * as I18n from "../../../../utils/translations/I18n";
import { FillUp } from "@vwpfs/mary-air-lib/components/air/04-helpers/FillUp";
import { Alignment, ButtonsWrapper, Orientation } from "@vwpfs/mary-air-lib/components/air/06-molecules/ButtonsWrapper";
import { Navbar } from "@vwpfs/mary-air-lib/components/air/07-organisms";
import { FlexRow } from "@vwpfs/mary-air-lib/components/air/03-base/Flex/Row";
import { FlexColumn } from "@vwpfs/mary-air-lib/components/air/03-base/Flex/Column";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";
import { IconNames } from "@vwpfs/mary-air-lib/components/air/05-atoms/Icon";
import { NavbarStack,
    NavbarStackContent, NavbarStackRight } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Stack";
import { NavbarTitle } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Title";
import { NavbarIcon } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Icon";
import { UserProps, General } from "@vwpfs/mary-air-lib/components/air/09-views/03-modals/AccountSettings/Tabs/General";
import { TabType, Tabs } from "@vwpfs/mary-air-lib/components/air/09-views/00-blocks/Tabs";

/**
 *
 */
interface OwnProps extends UserProps {
    id: string;
    closeModal: (id: string) => void;
    onLogout: (b?: boolean) => void;
}

/**
 *
 */
type Props = OwnProps;

/**
 *
 */
export class ModalAccountSettings
    extends React.Component<Props, {}> {

    /**
     *
     * @param props
     */
    public constructor(props: Props) {
        super(props);

        this.closeModal = this.closeModal.bind(this);
    }

    /**
     *
     */
    public render() {
        const tabs: TabType[] = [{
            key: "GENERAL",
            title: I18n.getText("mary.09-views.03-modals.accountsettings.tabs.general.title",
                "General") ?? "",
            description: "",
            component: General,
        }];
        return (
            <>
                <FlexRow isFixed>
                    <Navbar
                        theme={{
                            palette: ThemePalette.CONTRAST_TERTIARY,
                        }}
                    >
                        <NavbarStack>
                            <NavbarStackContent>
                                <NavbarTitle>
                                    {I18n.getText(
                                        "mary.09-views.03-modals.accountsettings.title",
                                        "Account settings")}
                                </NavbarTitle>
                            </NavbarStackContent>
                            <NavbarStackRight>
                                <NavbarIcon>
                                    <Button
                                        className={"scl-o-navbar__icon"}
                                        icon={IconNames.TIMES}
                                        link={{
                                            onClick: this.closeModal(),
                                        }}
                                    />
                                </NavbarIcon>
                            </NavbarStackRight>
                        </NavbarStack>
                    </Navbar>
                </FlexRow>
                <FlexRow
                    theme={{
                        palette: ThemePalette.CONTRAST_PRIMARY,
                    }}
                    isScrollable
                >

                    <FillUp>
                        <Container
                            theme={{
                                padding: {
                                    "": { y: 1 },
                                    "md": { y: 2 },
                                },
                            }}
                        >
                            <Tabs
                                tabs={tabs}
                                defaultTab={tabs[0]}
                                params={{
                                    user: this.props.user,
                                    onLogout: this.props.onLogout,
                                }}
                            />
                        </Container>
                    </FillUp>
                </FlexRow>
                <FlexRow isFixed>
                    <FlexColumn
                        theme={{
                            palette: ThemePalette.CONTRAST_TERTIARY,
                        }}
                    >
                        <Container
                            theme={{
                                padding: { "": { y: 3 } },
                            }}
                        >
                            <ButtonsWrapper
                                defaultOrientation={Orientation.HORIZONTAL}
                                orientations={{
                                    [ThemeBreakpoints.XS]: Orientation.VERTICAL,
                                    [ThemeBreakpoints.MD]: Orientation.HORIZONTAL,
                                }}
                                alignment={Alignment.RIGHT}>
                                <React.Fragment>
                                    <Button
                                        theme={{ palette: ThemePalette.CONTRAST_SECONDARY }}
                                        link={{ onClick: this.closeModal() }}
                                    >
                                        {I18n.getText(
                                            "mary.close",
                                            "Close")}
                                    </Button>
                                </React.Fragment>
                            </ButtonsWrapper>
                        </Container>
                    </FlexColumn>
                </FlexRow>
            </>
        );
    }

    private closeModal() {
        return () => this.props.closeModal(this.props.id);
    }
}
